import {buildTypedMultiTabPanel} from '../multi-tab-panel';
import {ModePermissions, SectionMode, TabID} from './types';

export const {MultiTabPanel, useTabActivator, useTabsContext, useModeContext} = buildTypedMultiTabPanel<TabID, SectionMode, ModePermissions>();
